/* One shared observer; decorative motion runs only on visible cards. */
(function () {
  if (window.FlorameCreateCardMotion || !window.IntersectionObserver) return;
  window.FlorameCreateCardMotion = true;
  var visible = new Set();
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function sync() {
    visible.forEach(function (card) {
      card.classList.toggle('is-mascot-visible', !document.hidden && !reduce.matches);
    });
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { visible.add(entry.target); entry.target.classList.add('is-card-revealed'); }
      else { visible.delete(entry.target); entry.target.classList.remove('is-mascot-visible'); }
    });
    sync();
  }, { threshold: 0.15 });
  document.querySelectorAll('.bq-hero').forEach(function (card) { observer.observe(card); });
  document.addEventListener('visibilitychange', sync);
  if (reduce.addEventListener) reduce.addEventListener('change', sync);
})();
